<div class="modal-header">
  <h4 class="modal-title pull-left"> A propos de EcoREC </h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal();">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" style="height: auto; padding: 15px 0">
  <div class="col-sm-12 text-center">
    <div class="col-sm-6">
      <!-- <img src="assets/images/kerlog_logo.bmp" alt="logo"> -->
      <!-- <img src="assets/images/logoKerlog.jpg" alt="logo"> -->
      <img src="assets/images/LOGO_KERLOG_RVB_.svg" alt="logo">
    </div>
    <div class="col-sm-6">
      <!-- <img src="assets/images/imgpsh_fullsize_anim.png" alt="logo"> -->
      <!-- <img src="assets/images/ecorec.svg" alt="logo"> -->
      <img src="assets/images/EcorecNew.svg" alt="logo"   style="margin-top: 10px;">
      
    </div>
  </div>
  <div class="col-sm-12 apropos">
    <div class="form-group col-sm-12">
      <label class="col-sm-5" style="padding: 0;"> Version : </label>
      <label class="col-sm-7"> {{objetInfo.VERSION }} </label>
    </div>
    <div class="form-group col-sm-12">
      <label class="col-sm-5" style="padding: 0;"> Dèrnière MAJ : </label>
      <label class="col-sm-7"> {{objetInfo.LAST_UPDATE }} </label>
    </div>
    <div class="form-group col-sm-12">
      <label class="col-sm-5" style="padding: 0;"> Tel : </label>
      <label class="col-sm-7"> {{objetInfo.TEL }} </label>
    </div>
    <div class="form-group col-sm-12">
      <label class="col-sm-5" style="padding: 0;"> Mail : </label>
      <label class="col-sm-7"> {{objetInfo.MAIL }} </label>
    </div>
    <div class="form-group col-sm-12">
      <label class="col-sm-5 p-0" style="height: 110px;line-height: 110px;"> Sécurité : </label>
      <label class="col-sm-7 p-0"> 
        <img  src="assets/images/04012024_112700_logo-ziwit-pentest-2024.svg" alt="ziwit-pentest" />
      </label>
    </div>
    <div class="form-group col-sm-12">
      <label class="col-sm-5" style="padding: 0;"> Nb licences : </label>
      <label class="col-sm-7"> {{objetInfo.NBR_LICENCE }} </label>
    </div>
    <div class="form-group col-sm-12" >
      <label class="col-sm-12" style="padding: 0;     white-space: pre-line;" [innerHTML]="objetInfo.COPYRIGHT"></label>
    </div>

    <div class="form-group col-sm-12">
      <textarea class="form-control" rows="5" readonly [(ngModel)]="objetInfo.TEXTEINFO"></textarea>
    </div>
  </div>
  <div class="text-right col-sm-12" style="margin: 10px 0;">
    <button type="button" class=" btn-close" (click)="common.closeModal(); "> Fermer </button>
  </div>
</div>